/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import ShapeEnum from 'shared/enum/shape';

import Now from 'shared/query/current.time';
import Galaxy from 'shared/query/galaxy';
import Navigation from 'shared/client/navigation';

import * as Coords from 'shared/geo/coords';


export default new Client([ Navigation, Galaxy, Now ], class
{
  constructor (navigation, galaxy, now)
  {
    this.now = now;

    this.galaxy = galaxy;
    this.navigation = navigation;

    this.source = navigation.getCurrent();
    this.target = navigation.getRawTarget();
  }


  onDone ()
  {
    const shape = this.navigation.getBehaviorShape();

    this.galaxy.setupBuilding(this.source.getCass(), this.target.getCass(), shape);
  }


  getError ()
  {
    const building = this.source.getZone().getBuilding();

    if (building == null)
    {
      return 'Zone requires a building to fire projectile.';
    }

    if (!building.canFireProjectiles())
    {
      return 'Building is not allowed to fire projectiles.';
    }

    if (this.source.equals(this.target))
    {
      return 'Building cannot attack zone it occupies.';
    }

    const targetDistance = this.__getDistance__();
    const maxDistance = building.getConstants().getWeaponRange();

    if (targetDistance > maxDistance)
    {
      return `Target is out of maximum range of ${maxDistance}.`;
    }

    const constants = building.getProjectileConstants();

    const currency = this.galaxy.getCurrentUser().getCurrency(this.now);

    if (currency < 1)
    {
      return 'Not enough currency to fire projectile';
    }

    /*if (!this.source.getZone().getEnergy().canSpend(constants.getPlanetStrength()))
    {
      return 'Not enough energy to fire projectile';
    }*/

    if (!this.target.getZone() && !this.target.getPlatform())
    {
      return 'Cannot attack empty space.';
    }

    return null;
  }


  __getDistance__ ()
  {
    return Coords.getDistance(this.source.getCoords(), this.target.getCoords());
  }


  getInitial ()
  {
    if (this.target == null)
    {
      return 'Select target zone';
    }

    return null;
  }


});
